/** The balance in the app header (ADR-0050): one quiet pill, a link to the Balance page. */
import { useQuery } from "@tanstack/react-query";
import { Wallet } from "lucide-react";
import { Link } from "wouter";
import { useWalletT } from "../../i18n";
import { fmtUsd } from "../../lib/fmt";
import { balanceQuery } from "./wallet";

export function BalanceChip() {
  const t = useWalletT();
  const q = useQuery(balanceQuery);
  const amount = q.data ? fmtUsd(q.data.balance) : "—";
  return (
    <Link
      href="/balance"
      aria-label={t("chip", { amount })}
      className="inline-flex h-8 items-center gap-1.5 rounded-full border border-border px-3 text-sm font-semibold tabular-nums transition-colors hover:border-foreground/40"
    >
      <Wallet className="size-3.5 text-muted-foreground" aria-hidden />
      {amount}
    </Link>
  );
}
